export const initialTodoState = {
  taskName: [],
};

export const counterInitialState = {
  count : 30 ,
  seconds : 60,
  start : false
}

